import './style.scss';

import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import LoadingSpinner from 'shared/components/ui/loadingSpinner';
import CartButton from './button';
import CartPreview from './preview';
import CartList from './list';
import FreeShippingMeter from './freeShippingMeter';
import Promo from '../promo';
import View from 'components/ui/view';
import Text from 'components/ui/text';
import { showPromo } from '../promo/actions';
import { selectPromo, removePromo } from '../cart/actions';

let Cart = class Cart extends React.Component {
  constructor(props) {
    super(props);
    this.state = { collapsed: true };
    this.toggleCollapsed = this.toggleCollapsed.bind(this);
  }

  toggleCollapsed() {
    this.setState(prevState => ({ collapsed: !prevState.collapsed }));
  }

  render() {
    const className =
      'cart-checkout' +
      (this.state.collapsed ? ' cart-checkout--collapsed' : '');
    const hasShippingMeter = !!this.props.subtotal && this.props.shipping;
    const subtotal = this.props.subtotal;
    const originalSubtotal = this.props.products
      .concat(this.props.engravings)
      .filter(p => p.originalSubtotal || p.subtotal)
      .reduce((sum, p) => sum + (p.originalSubtotal || p.subtotal), 0);
    const showDiscount = originalSubtotal > subtotal;

    return (
      <div>
        <div className="cart-checkout-summary">
          <div className="row middle-xs">
            <div className="col-xs text-bold" onClick={this.toggleCollapsed}>
              {this.state.collapsed ? (
                <span>
                  Show Order Summary{' '}
                  <span className="svg-icon svg-icon--down-arrow cart-checkout-summary__arrow" />
                </span>
              ) : (
                <span>
                  Hide Order Summary{' '}
                  <span className="svg-icon svg-icon--up-arrow cart-checkout-summary__arrow" />
                </span>
              )}
            </div>
            {!!this.props.products.length && (
              <div className="col-xs-3">
                <div className="cart-checkout-summary__price-heading text-right">
                  Total
                </div>
                <div className="cart-checkout-summary__price text-right">
                  ${(this.props.total || 0).toFixed(2)}
                </div>
              </div>
            )}
          </div>
        </div>

        <div className={className}>
          {hasShippingMeter && (
            <Fragment>
              <FreeShippingMeter subtotal={this.props.subtotal} />
              <View padding={{ sides: 'sm' }}>
                <hr className="light" />
              </View>
            </Fragment>
          )}

          <CartList
            checkout={true}
            className={
              'cart-checkout__list' +
              (hasShippingMeter ? ' cart-checkout__list--with-meter' : '')
            }
            onClick={this.props.openQuickView}
          />

          {!!subtotal && (
            <div className="cart-checkout__line-items">
              {this.props.loading && <LoadingSpinner green />}
              {this.props.line_items.map(line => (
                <div className="row" key={line.title + '-' + line.display}>
                  <div className="col-xs-12">
                    <LineItem
                      {...line}
                      showPromo={() => this.props.showPromo(true)}
                    />
                  </div>
                </div>
              ))}
              {showDiscount && (
                <div className="row">
                  <div className="col-xs-12">
                    <Text
                      success
                      weight="med"
                      className="cart-checkout__line-item text-right"
                    >
                      You saved ${(originalSubtotal - subtotal).toFixed(2)}
                    </Text>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>

        <Promo
          selectPromo={item => this.props.selectPromo(item, { checkout: true })}
          selectedPromo={this.props.promo}
          removePromo={() => this.props.removePromo({ checkout: true })}
          orderId={this.props.orderId}
        />
      </div>
    );
  }
};

function LineItem(props) {
  const { format, title, display } = props;
  const isPromo = format === 'PROMO';
  const hasPromo = isPromo && display !== 'ADD';
  const modifier = (format || title || '').toLowerCase().replace(/\W+/g, '-');
  const className =
    'cart-checkout__line-item' +
    (modifier ? ` cart-checkout__line-item--${modifier}` : '');

  return (
    <div className={className}>
      <div className="left">{title}</div>
      <div className="right text-right">
        {!isPromo ? (
          display
        ) : hasPromo ? (
          <div>
            <span>{display}</span>
            {props.showPromo && (
              <div
                className="link-text cart-checkout__change-promo"
                onClick={() => props.showPromo()}
              >
                Change Promo Code
              </div>
            )}
          </div>
        ) : (
          <span className="link-text" onClick={() => props.showPromo()}>
            {display}
          </span>
        )}
      </div>
    </div>
  );
}

Cart = connect(
  state => ({
    ...state.cart,
    orderId: state.checkout.id,
    shipping: state.address.shipping
  }),
  {
    showPromo,
    selectPromo,
    removePromo
  }
)(Cart);

export default Cart;
export { CartButton, CartPreview, LineItem };



// WEBPACK FOOTER //
// ./shared/components/cart/index.js